export default __webpack_public_path__ + "static/media/dotPattern1.81896797.svg";